import React from "react";
import "./faq.layout.sass";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import faqHeader from "../../assets/image/FaqHeader.png";
import {
	PanelGroup,
	Panel,
	Button,
	Form,
	FormGroup,
	FormControl,
	Row,
	Col,
	Icon,
	Alert,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectFaqQuestion } from "../../redux/modals/modals.selector";
import ModalTypes from "../../redux/modals/modals.types";
import { debounce } from "lodash";
import Axios from "axios";
import { Setting } from "../../setting";
import GridLoader from "../specialFeatures/SpecialFeatures.layout";
import { css } from "@emotion/react";

class FaqLayout extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searchWord: "",
			matched: "",
			Api: "",
			data: "",
		};
	}

	componentDidMount() {
		Axios.get(`${Setting.apiUrl}api/question/list`).then((res) => {
			this.setState({
				data: res.data.data,
				Api: res.data.data,
			});
		});
	}

	HandleSearch = (value) => {};

	render() {
		const HandleSearch = () => {
			this.setState({
				Api: this.state.data,
			});
			console.log(this.state);
			setTimeout(() => {
				if (document.getElementById("searchInput").value) {
					let searchWord = document.getElementById("searchInput").value;
					let arr = [];
					this.state.Api.map((item) =>
						arr.push([...arr, item.question.split(" ")])
					);
					arr = this.state.Api.map((item) => item.question.split(" "));
					let find = arr.filter((item) =>
						item.find((x) => x === searchWord.split(" ")[0])
					);
					let AllQuestion = find.map((x) => x.join(" "));
					let findedQuestion = this.state.Api.map((item) => item.question);
					// let AllQuestion = this.state.Api.map(item => item.question == find.map(x => x.join(' ')));
					console.log("findedQuestion: " + findedQuestion);
					console.log("AllQuestion : " + AllQuestion);
					let API = this.state.Api.filter(
						(item) => item.question == AllQuestion[0]
					);
					console.log(API);
					this.setState({
						Api: API,
					});
				} else {
					this.setState({
						Api: this.state.data,
					});
				}
			}, 100);
		};
		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
			position: relative;
		`;
		return (
			<div>
				<SubHeaderComponent
					imageSrc={faqHeader}
					pageName="سوالات متداول"
				/>
				<div className="faq-layout">
					<div className="faq-search">
						<Form
							className="faq-search-form"
							onSubmit={HandleSearch}
						>
							<FormGroup>
								<Row>
									<Col
										md={4}
										xs={24}
									>
										<Button
											type="submit"
											className="fag-search-btn"
											size="lg"
										>
											جستجو
										</Button>
									</Col>
									<Col
										md={20}
										xs={24}
									>
										<FormControl
											onChange={(value) => this.HandleSearch(value)}
											id="searchInput"
											size="lg"
											placeholder="جستجو کنید"
										/>
									</Col>
								</Row>
							</FormGroup>
						</Form>
					</div>
					<div className="faq-list">
						<div className="faq-list-title">
							<ul>
								<li>
									<span>فهرست</span>
								</li>
							</ul>
						</div>
						<div className="faq-list-questions">
							<PanelGroup
								accordion
								defaultActiveKey={1}
								bordered
							>
								{this.state.Api ? (
									this.state.Api.map((question) => {
										console.log(question);
										return (
											<Panel
												key={question.id}
												header={
													<div>
														<Icon
															className="panel-icon"
															icon="question2"
														/>
														{console.log(Setting.apiUrl)}
														{question.question}
													</div>
												}
												eventKey={question.id}
											>
												{question.file_type === "video" ? (
													<a href={question.link}>
														<img
															className="faq-cover"
															src={`${Setting.apiUrl}${question?.cover}`}
														/>
													</a>
												) : (
													<p>{question.answer}</p>
												)}
											</Panel>
										);
									})
								) : (
									<GridLoader
										css={override}
										size={15}
										margin={8}
										color="#FF8F3C"
									/>
								)}
							</PanelGroup>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	faqQuestion: selectFaqQuestion,
});
const mapDispatchToProps = (dispatch) => ({
	ToggleFaqQuestion: () => dispatch({ type: ModalTypes.TOGGLE_FAQ_QUESTION }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqLayout);
